import { render, staticRenderFns } from "./RecentBlogCard.vue?vue&type=template&id=51ac7ab0&"
import script from "./RecentBlogCard.vue?vue&type=script&lang=js&"
export * from "./RecentBlogCard.vue?vue&type=script&lang=js&"
import style0 from "./RecentBlogCard.vue?vue&type=style&index=0&id=51ac7ab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports